import { render } from "./content-logs-view-page.vue?vue&type=template&id=5ed8a713"
import script from "./content-logs-view-page.vue?vue&type=script&lang=ts"
export * from "./content-logs-view-page.vue?vue&type=script&lang=ts"

import "./content-logs-view-page.vue?vue&type=style&index=0&id=5ed8a713&lang=less"
script.render = render

export default script